// extracted by mini-css-extract-plugin
module.exports = {"container":"Tags_container__slYvn","tag":"Tags_tag__yQv4F","primary":"Tags_primary__pKpf_"};